import { useMemo } from 'react';
import { useCurrentUser } from 'state/current-user/current-user.thunk';
import { ROLES } from 'constants/roles';

export const useReadOnly = (): boolean => {
  const {
    data: { authority },
  } = useCurrentUser() as { data: { authority?: string } };

  return useMemo(() => authority !== ROLES.SUPER_ADMIN, [authority]);
};
